import { connect } from 'react-redux'
import ContextMenu from './context-menu'
import {
  deleteAssessmentFile,
  openInvitationAssessmentDialog
} from '../../../../../../../stores/assessment/assessment.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapDispatchToProps = (dispatch, { id }) => ({
  onDelete: () => dispatch(deleteAssessmentFile(id)).catch(errorHandler),
  onOpenInvitationAssessmentDialog: () =>
    dispatch(openInvitationAssessmentDialog(id))
})

export default connect(
  null,
  mapDispatchToProps
)(ContextMenu)
